import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { BsModalService } from 'ngx-bootstrap';
import { SocketService } from '../../common/services/Socket.service';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from '../../common/services/Chat.service';
import { Message } from '../../common/models/message';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ChatComponent } from '../../pages/admin/icontact/chat/chat.component';
import _ from 'lodash';
import { UserService } from '../../common/services/User.service';
import { PushNotificationsService } from '../../common/services/Notifycation.service';
import { SocialService } from '../../common/services/Social.service';
import * as socketIo from 'socket.io-client';
import { QueueService } from 'app/common/services/Queue.service';
import { TicketService } from 'app/common/services/Ticket.service';
import * as Sentry from '@sentry/browser';
import { showPhoneNumberInString } from '../../common/utils/common';
import { BaseComponent } from '../../components/base.component';
import { Severity } from '@sentry/browser';
import { SocketListener } from './socket.listener';
import { ChatListener } from '../../pages/admin/icontact/chat/chat.listener';
import { Role } from '../../pages/admin/icontact/setting/expert/agent/agent.const';

declare var $: any;
declare const WebPush: any;
declare const DetectRTC: any;
// webrtc state
declare const state: any;

@Component({
  selector: 'admin-header',
  templateUrl: './admin-header.template.html',
  styleUrls: ['admin-header.css'],
  providers: [UserService, BsModalService, SocialService, QueueService],
})
export class AdminHeaderComponent extends BaseComponent {
  public no_image = 'assets/images/contact.png';
  data: any;
  detail: any;
  items: any[] = [];
  allCalloutQueues: any[] = [];
  limit = 10;
  calloutQueue: any;
  size = 10;
  typeNav = '';
  socket: any = null;
  public phone_out = '';

  collapsed = false;

  code = '';
  avaiable_status: any = 'AVAILABLE';
  public channelStatus: any = {
    chatStatus: 'AVAILABLE',
    emailStatus: 'AVAILABLE',
    facebookStatus: 'AVAILABLE',
    zaloStatus: 'AVAILABLE',
  };
  public noCalling: any = true;
  public is_show_setting = false;
  public is_show_detail = false;
  public isVoiceActivated = false;
  public image_contact = 'assets/images/contact.png';
  public phone_calling: any = '';
  public phoneLogin = true;
  public checkRegisterRtc = false;

  public fb_unread = 0;
  public chat_unread = 0;
  // socket
  ioConnection: any;
  messages: Message[] = [];
  public tab_top: any = null;
  public sipgatewayUrl: any = null;
  // public sippass: any = "6366868";
  public sippass: any = 'azA2023xZBc';
  public is_calling = false;
  public call_id: any;
  public call_type: any;
  public auto_answer = 0;
  public NotificationOption: { showOption: Number } = {
    showOption: 1,
  };
  public isOpens: any = { status: false, data: {} };
  public NotificationDatas: any = [];

  public invite_msg = '';
  public msg_obj: any = {};
  public formFields = [];
  public currentPhoneType = 0;
  public visibility = true;

  @ViewChild('confirm_invite') confirmInvite: ElementRef;
  @ViewChild('confirm_forward') confirmForward: ElementRef;
  @ViewChild('action_modal') action_modal: ElementRef;

  @ViewChild('dropdownv2') dropdown: ElementRef;
  // modal chat
  bsModalRef: BsModalRef;
  @Output('newTab') newTab = new EventEmitter();
  protected readonly showPhoneNumberInString = showPhoneNumberInString;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private router: Router,
    private socketService: SocketService,
    private userService: UserService,
    private queueService: QueueService,
    private chatService: ChatService,
    private ticketService: TicketService,
    private notifycationService: PushNotificationsService,
    private socialService: SocialService,
    private elRef: ElementRef,
    private socketListener: SocketListener,
    private chatListener: ChatListener
  ) {
    super(changeDetector, toastr, modalService);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.visibility = false;
        // Xử lý khi người dùng rời tab
      } else {
        this.visibility = true;
        // Xử lý khi người dùng quay lại tab
      }
    });
    // lang nghe su kien webrtc phone
    state.subscribe(this.onPhoneEvent);
    state.scope = this;
    this.handerSocketChat();
    this.getChatUnread();
    this.getAllCalloutQueue();
    this.socketService.missionAnnounced$.subscribe(mission => {
      if (mission.action == 'updateNotify') {
        this.chat_unread = this.chat_unread - mission.data >= 0 ? this.chat_unread - mission.data : 0;
      } else if (mission.action == 'hideVoiceBox') {
        this.hideVoiceBox();
      }
    });
    this.is_calling = false;
    this.noCalling = true;
    this.notifycationService.requestPermission();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.dropdown && this.dropdown.nativeElement) {
      if (!this.dropdown.nativeElement.contains(event.target)) {
        this.isOpens.status = false;
        this.isOpens.data = {};
      }
    }
  }

  ngOnDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
    this.chatService.closeSocket();
  }

  toggleDropdown(data) {
    if (data._id == this.isOpens.data._id) {
      this.isOpens.status = !this.isOpens.status;
    } else {
      this.isOpens.status = true;
      this.isOpens.data = data;
    }
  }

  getObjectKeys(data) {
    return Object.keys(data).map(key => ({ key, value: data[key] }));
  }

  handleChangeNotificationStatus(data) {
    this.isOpens.status = false;
    this.isOpens.data = {};
  }

  handleOpenNotification() {}

  ngOnInit() {
    const status = localStorage.getItem('status');
    this.avaiable_status = status;
    if (this.socket) {
      this.socket.close();
    }
    const spy = localStorage.getItem('Spying');
    if (spy) {
      return;
    }
    const socketUrl = environment.url_socket + localStorage.getItem('Access-Token');
    this.socket = socketIo(socketUrl, { transports: ['websocket'] });
    this.socketService.setSocket(this.socket);
    const self = this;
    this.socket.on(
      'connect',
      function () {
        console.log('Client has connected to the server! socket_id ' + this.socket.id);
        // this.login();
        setTimeout(() => {
          self.login();
        }, 1500);
      }.bind(this)
    );

    this.socket.on(
      'message',
      function (data) {
        // hàm lắng nghe event trả về từ server
        const msg = data;
        switch (msg.objectId) {
          case environment.code.LOGOUT_RESPOND_ID: {
            this.logoutOthers();
            break;
          }
          case environment.code.VOICE_ACTIVATED: {
            console.log('VOICE_ACTIVATED');
            this.afterLogin(msg.data);
            break;
          }
          case environment.code.LOGIN_RESPOND_ID: {
            localStorage.setItem('username', msg.data.username);
            localStorage.setItem('agentId', msg.data.agentId);
            state.phoneType = msg.data.phoneType;
            this.currentPhoneType = Number(msg.data.phoneType);
            state.auto_answer = msg.data.autoAnswer;
            this.socketListener.onStatusReceived.emit({
              code: environment.code.LOGIN_RESPOND_ID,
              msg: msg,
            });
            break;
          }
          case environment.code.USER_PHONE_SELECT: {
            this.is_calling = false;
            this.auto_answer = msg.data.autoAnswer;
            if (this.isVoiceActivated) {
              if (msg.data.status == 'OK') {
                this.throwSuccess('Cấu hình Phone voice thành công!');
                this.phoneLogin = msg.data.phoneType == 0;
                if (this.phoneLogin) {
                  this.unRegisterRTC();
                  this.registerRTC();
                  this.checkBrowser();
                } else {
                  if (this.checkRegisterRtc) {
                    this.unRegisterRTC();
                  }
                }
              } else {
                this.throwError('Cấu hình Phone voice thất bại!');
              }
            }
            break;
          }
          case environment.code.CHANGE_AGENT_STATUS_RESPOND_ID: {
            this.socketListener.onStatusReceived.emit({
              code: environment.code.CHANGE_AGENT_STATUS_RESPOND_ID,
              msg: msg,
            });
            break;
          }
          default: {
            this.listen(msg);
            this.socketService.execMsg(this.user.email, msg.objectId, msg.data, this.isVoiceActivated, this.visibility);
            break;
          }
        }
      }.bind(this)
    );

    this.socket.on('disconnect', function () {
      console.log('The client has disconnected!');
    });
  }

  sendMessage(event) {
    // hàm gửi event cho server
    const appMessage = { objectId: event.objectId, data: event };
    this.socket.emit('message', appMessage);
  }

  getAllCalloutQueue() {
    this.queueService.listCalloutQueues().subscribe(rs => {
      if (rs.status == 200 && !rs.error) {
        this.allCalloutQueues = rs.data.queues;
        let queue = localStorage.getItem('calloutDefault');
        if (!queue) {
          if (this.allCalloutQueues.length > 0) {
            queue = this.allCalloutQueues[0].QUEUE_ID;
          } else {
            queue = '';
          }
          localStorage.setItem('calloutDefault', queue);
        }
        this.calloutQueue = queue;
      }
    });
  }

  handerSocketChat() {
    this.chatService.initSocket(this.user.tenant_id, this.user._id, this.user.role, this.user.name, this.user._id);
    this.chatService.onUpdateChatting().subscribe((message: any) => {
      this.chatService.agentsInTicket(message.ticket_id, {}).subscribe(res => {
        if (res.status == 200 && !res.error) {
          for (const agent of res.data) {
            try {
              if (
                (this.user.role === Role.Administrator || this.user._id == agent._id) &&
                !res.data.find(r => r._id == message.chatter_id)
              ) {
                this.chatListener.updateUnreadMessage(1, [message.ticket_id]);
              }
              if (this.user._id === agent._id && !res.data.find(r => r._id == message.chatter_id)) {
                if (!this.router.url.includes('chatting')) {
                  let msg = message.content;
                  if (msg.length > 24) {
                    msg = msg.substring(0, 24) + '...';
                  }
                  this.throwInfo(msg, 'Tin nhắn từ ' + message.chatter_name, 4000, {
                    data: message,
                    channel: 'unread',
                  });
                }
              }
            } catch (e) {
              console.error(e);
            }
          }
        }
      });
    });

    this.chatService.onInviteChat().subscribe((message: any) => {
      console.log(message.from_user + ' mời bạn tham gia chat với khách hàng ' + this.user._id);
      this.msg_obj = message;
      if (message.agent_id == this.user._id) {
        if (message.status == 'invite') {
          this.invite_msg = message.from_user + ' mời bạn tham gia chat với khách hàng';
          const config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
          };
          this.modalRef = this.modalService.show(this.confirmInvite, config);
        }
      }
    });

    this.chatService.onForwardChat().subscribe((message: any) => {
      console.log(message.from_user + ' chuyển cuộc hội thoại tới bạn hỗ trợ ' + this.user._id);
      this.msg_obj = message;
      if (message.agent_id == this.user._id) {
        if (message.status == 'forward') {
          this.invite_msg = message.from_user + ' chuyển cuộc hội thoại tới bạn hỗ trợ';
          const config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
          };
          this.modalRef = this.modalService.show(this.confirmForward, config);
        }
      }
    });

    this.chatService.onUpdateChattingInternal().subscribe((message: any) => {
      const check = _.find(message.agents, { agent_id: this.user.id });
      if (check) {
        this.chat_unread = this.chat_unread + 1;

        this.userService.find({ _id: message.chatter_id }).subscribe(rs => {
          if (rs.status == 200 && !rs.error) {
            this.notifycationService.generateNotification([
              {
                title: message.chatter_name,
                content: message.content,
                icon: rs.data.avatar ? rs.data.avatar : this.no_image,
              },
            ]);
          }
        });
      }
    });
  }

  rejectInviteChat() {
    console.log('refuseinvite chat from ' + this.msg_obj.from_user_id + ' of ' + this.user._id);
    this.chatService.inviteChat(
      this.msg_obj.from_user_id,
      this.user._id,
      this.user.name,
      this.user.tenant_id,
      this.msg_obj.ticket_id,
      'reject'
    );
    this.modalRef.hide();
  }

  rejectForwardChat() {
    console.log('refuseforward chat from ' + this.msg_obj.from_user_id + ' of ' + this.user._id);
    const payload = {
      agent_id: this.msg_obj.from_user_id,
      from_user_id: this.user._id,
      from_user: this.user.name,
      tenant_id: this.user.tenant_id,
      ticket_id: this.msg_obj.ticket_id,
      status: 'reject',
    };
    this.chatService.forwardChat(payload);
    this.modalRef.hide();
  }

  acceptInviteChat() {
    console.log('accept invite chat from ' + this.msg_obj.from_user_id + ' of ' + this.user._id);
    this.modalRef.hide();
    this.ticketService
      .updateMany({ _id: this.msg_obj.ticket_id }, { $addToSet: { in_room: this.user._id } })
      .subscribe(res => {
        if (res.status == 200 && res.error == false) {
          this.chatService.join(this.msg_obj.ticket_id);
          this.socketService.updateChatData({});
          // this.loadData();
          this.chatService.inviteChat(
            this.msg_obj.from_user_id,
            this.user._id,
            this.user.name,
            this.user.tenant_id,
            this.msg_obj.ticket_id,
            'accept'
          );

          this.chatService.send(this.msg_obj.ticket_id, {
            chatter_id: this.user._id,
            chatter_name: this.user.name,
            chatter_type: 'agent',
            content: '',
            type: 'action-join', // image , file
            avatar: '',
            date: Date.now(),
          });
        }
      });
  }

  acceptForwardChat() {
    console.log('accept forward chat from ' + this.msg_obj.from_user_id + ' of ' + this.user._id);
    const payload = {
      agent_id: this.msg_obj.from_user_id,
      from_user_id: this.user._id,
      from_user: this.user.name,
      tenant_id: this.user.tenant_id,
      ticket_id: this.msg_obj.ticket_id,
      status: 'accept',
    };
    this.modalRef.hide();
    this.ticketService
      .updateMany(
        { _id: this.msg_obj.ticket_id },
        {
          $set: { receiver_id: this.user._id },
          $pull: { in_room: this.msg_obj.from_user_id },
        }
      )
      .subscribe(res => {
        if (res.status == 200 && res.error == false) {
          this.chatService.join(this.msg_obj.ticket_id);
          this.chatService.forwardChat(payload); // send socket
          // this.loadData();
          this.socketService.updateChatData({});
          this.chatService.send(this.msg_obj.ticket_id, {
            chatter_id: this.user._id,
            chatter_name: this.user.name,
            chatter_type: 'agent',
            content: '',
            type: 'action-join', // image , file
            avatar: '',
            date: Date.now(),
          });
        }
      });
    this.ticketService
      .updateMany({ _id: this.msg_obj.ticket_id }, { $addToSet: { in_room: this.user._id } })
      .subscribe(res => {});
  }

  redirectTo(url) {
    this.router.navigate([url]);
  }

  getChatUnread() {
    this.chatService.unread().subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.chatListener.updateOfflineChannel(res.data.offline || 0, true);
        this.chatListener.updateUnreadMessage(res.data.unread || 0, [], true);
      }
    });
  }

  unRegisterRTC() {
    this.checkRegisterRtc = false;
    (window as any).unregister();
  }

  registerRTC() {
    if (this.sipgatewayUrl) {
      (window as any).init_ua(this.user.agent_id, this.sippass, this.sipgatewayUrl, 'wss://' + this.sipgatewayUrl);
    }
    const state = (window as any).state;
    if ((window as any).ua) {
      (window as any).ua.on(
        'newRTCSession',
        function (e) {
          this.is_show_detail = true;
          this.noCalling = false;
          const session = e.session;
          session.on(
            'ended',
            function (e) {
              this.noCalling = true;
              this.is_calling = false;
              this.call_type = '';
            }.bind(this)
          );

          session.on(
            'failed',
            function (e) {
              this.noCalling = true;
              this.is_calling = false;
              this.call_type = '';
            }.bind(this)
          );
        }.bind(this)
      );

      (window as any).ua.on(
        'registered',
        function (e) {
          this.checkRegisterRtc = true;
        }.bind(this)
      );
    }
    this.checkRegisterRtc = state.status == 'registered';
  }

  activateVoice() {
    this.socketService.activateVoice();
  }

  webRtcAnswer() {
    (window as any).answer_call();
    Sentry.captureMessage(
      'CALL_ACTION: uaid:' + this.user.agent_id + ' answerCall: ' + this.phone_calling,
      Sentry.Severity.Log
    );
    this.is_show_detail = false;
    this.is_calling = true;
  }

  webRtcReject() {
    Sentry.captureMessage(
      'CALL_ACTION: uaid:' + this.user.agent_id + ' rejectCall: ' + this.phone_calling,
      Sentry.Severity.Log
    );
    if (this.call_id) {
      this.socketService.execEndCall({ callId: this.call_id });
    }
    this.noCalling = true;
    this.is_show_detail = false;
    this.is_calling = false;
  }

  /**
   * Thực hiện Outcall
   */
  execCall() {
    if (this.phone_out) {
      Sentry.captureMessage(
        'CALL_ACTION: uaid:' + this.user.agent_id + ' execCall: ' + this.phone_out,
        Sentry.Severity.Log
      );
      this.phone_out = this.phone_out.replace(/\s+/g, '');
      this.socketService.execCall(this.phone_out);
      // if (this.auto_answer == 1) {
      //   this.is_calling = true;
      // }
      this.is_show_detail = false;
      this.is_calling = true;
    }
  }

  onBackspace() {
    this.phone_out = this.phone_out.substring(0, this.phone_out.length - 1);
  }

  onclick(number) {
    this.phone_out += number;
  }

  clear_phone_out() {
    this.phone_out = '';
  }

  showMore(): void {
    window.open('notify_manager');
  }

  toggle_sidebar() {
    this.collapsed = !this.collapsed;
  }

  voice(type) {
    this.currentPhoneType = type;
    // 0: webrtc, 1: sipphone can dang nhap, 2: sipphone khong can dang nhap, 3: so di dong
    this.socketService.voiceSetting({
      phoneType: type,
    });
  }

  changeAutoAnswer() {
    this.socketService.voiceSetting({
      autoAnswer: this.auto_answer == 0 ? 1 : 0,
    });
  }

  changeCalloutQueue() {
    localStorage.setItem('calloutDefault', this.calloutQueue);
  }

  forceAnswer() {
    const self = this;
    this.is_show_detail = false;
    this.is_calling = true;
    setTimeout(() => {
      self.webRtcAnswer();
    }, 1000);
  }

  hideVoiceBox() {
    this.is_show_detail = false;
    this.is_calling = true;
  }

  listen(msg) {
    switch (msg.objectId) {
      case environment.code.NEW_EMAIL_RESPOND_ID: {
        this.handleTitle(1);

        this.throwInfo(msg.emailSubject ? msg.emailSubject : msg.title, msg.emailFrom);
        break;
      }
      case environment.code.OUT_CALL_RESPONSE_ID: {
        this.phone_calling = msg.data.caller;
        this.call_id = msg.data.callId;
        this.call_type = 'CALL_OUTBOUND';
        if (msg.data.errorCode == 'OK') {
          Sentry.captureMessage(
            'CALL_ACTION: uaid:' + this.user.agent_id + ' initCallOut: ' + this.phone_calling + ' Successfully',
            Sentry.Severity.Log
          );
          if (this.isVoiceActivated && this.checkRegisterRtc) {
            if (
              this.auto_answer == 1 ||
              msg.data.callId.includes('HAPPYCALL') ||
              msg.data.callId.includes('ZALO') ||
              (msg.data.ticketId && msg.data.ticketId != null && msg.data.ticketId != '')
            ) {
              this.forceAnswer();
            }
          }
        } else if (msg.data.errorCode != 'SENDOK') {
          this.noCalling = true;
          this.is_show_detail = false;
          this.is_calling = false;

          let error = 'Không thể kết nối tới Web Phone';
          if (msg.data.errorCode == 'IN_BLACKLIST') {
            error = 'Khách hàng trong danh sách DNC';
          } else if (msg.data.errorCode == 'IN_INVALID_QUEUE') {
            error = 'Đầu số gọi ra không được phép';
          } else if (msg.data.errorCode == 'GATEWAY_INACTIVE') {
            error = 'Không thể kết nối tới Sip Trunk';
          } else if (msg.data.errorCode == 'PERMISSION_DENY') {
            error = 'Không được phép gọi ra';
          } else if (msg.data.errorCode == 'INCALL') {
            error = 'Bạn đang trong cuộc gọi khác';
          }
          Sentry.captureMessage(
            'CALL_ACTION: uaid:' +
              this.user.agent_id +
              ' initCallOut: ' +
              this.phone_calling +
              ' faild reason: ' +
              error,
            Sentry.Severity.Log
          );
          this.throwError(error);
        }
        break;
      }
      case environment.code.RING_AGENT_RESPOND_ID: {
        // this.is_show_detail = true;
        this.noCalling = false;
        this.handleTitle(1);
        this.phone_calling = msg.data.caller;
        this.call_type = msg.data.callType;
        this.call_id = msg.data.callId;
        const self = this;
        if (this.isVoiceActivated && this.checkRegisterRtc) {
          Sentry.captureMessage(
            'CALL_ACTION: uaid:' + this.user.agent_id + ' initCallIn: ' + this.phone_calling + ' Successfully',
            Sentry.Severity.Log
          );
          if (msg.data.campaignId) {
            if (this.auto_answer == 1 && !(msg.data.callId.includes('HAPPYCALL') || msg.data.callId.includes('ZALO'))) {
              this.forceAnswer();
            }
          } else if (this.auto_answer == 1 && this.call_type == 'CALL_INBOUND') {
            this.forceAnswer();
          }
        }
        if (this.auto_answer == 1) {
          this.is_calling = true;
        }
        break;
      }

      case environment.code.AGENT_ANSWER_RESPOND_ID: {
        this.handleTitle(-1);
        this.is_show_detail = false;
        this.is_show_setting = false;
        this.call_id = msg.data.callId;
        this.noCalling = false;
        this.is_calling = true;
        break;
      }
      case environment.code.AGENT_END_CALL_RESPOND_ID: {
        this.is_show_detail = false;
        this.is_show_setting = false;
        this.noCalling = true;
        this.call_id = null;
        this.is_calling = false;
        break;
      }
      case environment.code.END_CALL_RESPOND_ID: {
        this.is_show_detail = false;
        this.is_show_setting = false;
        this.noCalling = true;
        this.call_id = null;
        this.is_calling = false;
        break;
      }
      default:
        break;
    }
  }

  changeChannelStatus(channel) {
    const status = this.channelStatus[channel] == 'AVAILABLE' ? 'NOT AVAILABLE' : 'AVAILABLE';
    this.channelStatus[channel] = status;
    const data = {};
    data[channel] = status;
    this.socketService.changeAgentStatus(data);
  }

  responseChangeAvaiable(status) {
    this.userService.update(this.user._id, { avaiable_status: status }).subscribe(rs => {
      if (rs.status == 200) {
        localStorage.setItem('User', JSON.stringify(rs.data));
        localStorage.setItem('status', status.toString());
        this.avaiable_status = status.toString();
      }
    });
  }

  login() {
    if (!this.socket || !this.user.agent_id) {
      Sentry.captureMessage(
        `Tenant: ${this.user.tenant_id}|User: ${this.user._id}| Mất kết nối đến server!(wss disconnect now)`,
        Severity.Error
      );
      this.throwError('Mất kết nối đến server. Vui lòng thử lại sau!');
      return;
    }
    this.socket.send({
      objectId: environment.code.LOGIN_REQUEST_ID,
      data: {
        objectId: environment.code.LOGIN_REQUEST_ID,
        avatar: this.user.avatar,
        username: this.user.email,
        name: this.user.name,
        agentId: this.user.agent_id,
        userType: this.user.role,
        token: localStorage.getItem('Access-Token'),
        tenantId: this.user.tenant_id || this.user._id,
        groupId: this.user.group_id,
        shiftId: 1,
      },
    });
  }

  profile() {
    this.socketService.opentab(this.user, 'user', 'edit');
  }

  showBoxVoiceSetting() {
    this.is_show_setting = !this.is_show_setting;
  }

  showBoxDetail() {
    this.is_show_detail = !this.is_show_detail;
    this.is_show_setting = false;
  }

  showBoxChat() {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.bsModalRef = this.modalService.show(ChatComponent, config);
  }

  handleTitle(number) {}

  logoutOthers() {
    this.unRegisterRTC();
    console.log('Try to logout others!!!');
    console.log('Logged out others!!!');
    localStorage.clear();
    const closeFunction = this.elRef.nativeElement.ownerDocument.defaultView.closeAllModals;
    if (closeFunction) {
      closeFunction();
    }
    this.router.navigate(['/login']);
  }

  onchangeTab(value) {
    this.NotificationOption.showOption = Number(value);
  }

  onPhoneEvent(data, scope) {
    console.log('onPhoneEvent ' + data);
    scope.processEvent(data);
  }

  processEvent(data) {
    // do something
    if ('failed' == data) {
      this.socketService.alertPhoneFailed({});
    } else if (data.error) {
      this.throwError(data.error);
    }
  }

  protected handleToastTap(event = { data: {}, channel: 'unread' }) {
    if (!this.router.url.includes('chatting')) {
      this.router.navigate(['/chatting']);
    }
    this.chatListener.openChat({
      data: event.data,
      channel: event.channel,
    });
  }

  private checkBrowser() {
    const constraints = { audio: true };
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(stream => {
        this.throwSuccess('Kết nối tới thiết bị nghe gọi của bạn thành công!');
      })
      .catch(e => {
        if (DetectRTC.isWebRTCSupported === false) {
          this.throwError(
            'Trình duyệt của bạn không hỗ trợ thiết bị liên bị nghe gọi, xin vui lòng thử trình duyệt khác!'
          );
        }
        if (DetectRTC.hasMicrophone === false) {
          this.throwError(
            'Không thể kết nối tới thiết bị nghe gọi của bạn.Hãy kiểm tra lại tai nghe và micro của bạn!'
          );
        }
        if (
          DetectRTC.hasSpeakers === false &&
          (DetectRTC.browser.name === 'Chrome' || DetectRTC.browser.name === 'Edge')
        ) {
          this.throwError('Micro của bạn gặp vấn đề. Xin vui lòng kiểm tra lại micro của bạn!');
        }
      });
  }

  private afterLogin(data) {
    this.phoneLogin = data.phoneType == 0;
    this.currentPhoneType = Number(data.phoneType);
    this.sipgatewayUrl = data.sipGatewayUrl;
    if (data.sippass !== undefined) {
      this.sippass = data.sippass;
    }
    this.isVoiceActivated = data.isVoiceActivated;
    state.isVoiceActivated = data.isVoiceActivated;
    if (data.isVoiceActivated) {
      if (this.phoneLogin) {
        if (this.checkRegisterRtc) {
          this.unRegisterRTC();
        }
        this.registerRTC();
        this.checkBrowser();
      }
    } else {
      if (this.checkRegisterRtc) {
        this.unRegisterRTC();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/admin-header.component.ts